import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('connection_to_different_nisation_is_not_allowed'),
    description: defineMessage('bounded_integrationname_nkcontact_ussupportlink'),
    cancelButtonText: defineMessage('cancel'),
};
